import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { Icon } from '@reservamos/elements';
import { getDayTime } from 'utils/trips/parseTripDetails';

/**
 * Icon that represents the day time
 * @param {Object} props - Props
 * @param {Object} props.time - Time
 * @param {string} props.size - Icon size at desktop (default 'M')
 * @param {string} props.mobileSize - Icon size at mobile (default 'S')
 * @returns
 */
const TimeIcon = ({ time, size, mobileSize }) => {
  const convertedTime = time.hours ? time.hours() : moment(time).hours();
  let timeIcon = _.capitalize(getDayTime(convertedTime));
  timeIcon = timeIcon === 'Earlymorning' ? 'EarlyMorning' : timeIcon;

  return <Icon size={size} type={timeIcon} mobileSize={mobileSize} />;
};

TimeIcon.propTypes = {
  time: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  size: PropTypes.string,
  mobileSize: PropTypes.string,
};

TimeIcon.defaultProps = {
  size: 'M',
  mobileSize: 'S',
};
export default TimeIcon;
